import React from "react";

class PriceRulesForDateRangeDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row.price_rules_for_date_range && this.props.row.price_rules_for_date_range.length > 0 ) {
      const price_rules_for_date_range = this.props.row.price_rules_for_date_range.map((price_rule, idx)=> {
        if(this.props.row.auto_price_type === "pace") {
          if(price_rule.pace_selector != null) {
            return <li key={this.props.row.id}>{`${I18n.t(price_rule.pace_selector)}`}</li>  
          } else {
            return <li key={this.props.row.id}>{`${I18n.t("none")}`}</li>
          }
        } else {
          if (price_rule.occupancy_comparator != null) {
            return <li key={this.props.row.id}>{`${I18n.t(price_rule.occupancy_comparator)} ${this.formatPercentage(price_rule.occupancy_percentage)}`}</li>
          } else {
            return <li key={this.props.row.id}>{`${I18n.t("none")}`}</li>
          }
        } 
      })
      return (
        <ul className="RoomTypesDataType">{price_rules_for_date_range}</ul>
      );
    } else {
      return <div className="none">{I18n.t('none')}</div>
    }
  }
  
  formatPercentage(num) {
    return parseFloat((num * 100).toFixed(2)) + "%"
  }
}

export default PriceRulesForDateRangeDataType;